import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	teamNonFinal: {
		id: 'eoc-changeboarding.transition-home.teams-concept-step.teams-table.team-non-final',
		defaultMessage: 'Team',
		description: 'First row title that shows name of team',
	},
	viewNonFinal: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX - ENABLING FLAT LINT CONFIG
		id: 'eoc-changeboarding.transition-home.teams-concept-step.teams-table.view-non-final',
		defaultMessage: 'View team',
		description: 'Call to action to view team, redirects user to team profile page',
	},
	memberCountNonFinal: {
		id: 'eoc-changeboarding.transition-home.teams-concept-step.teams-table.member-count-non-final',
		defaultMessage: '{count, plural, one {{count} member} other {{count} members}}',
		description: 'Indicator of how many members are in the team',
	},
});
